import React from 'react'
import { t } from 'src/translations'
import { StyleMetaProps } from 'public/components/default_template/meta/StyleMeta'
import { SiteRestaurantLocation, SiteTheme } from 'shared/js/types'
import { RequestContextProps } from 'src/lib/js/context'
import { TrackingEvents } from 'src/shared/components/common/tracking/TrackingEvents'
import WithFallback500 from './WithFallback500'

const OOFallback500 = ({
  staticContext,
  meta,
  siteTheme,
  rxName,
  rxLocation,
  errorMessage
}: Partial<
  {
    meta?: StyleMetaProps
    siteTheme?: SiteTheme
    rxName?: string
    rxLocation?: SiteRestaurantLocation | null
    errorMessage?: string
  } & RequestContextProps
>) => {
  return (
    <WithFallback500
      title={t('oo-fallback-500.title')}
      subtitle={t('oo-fallback-500.subtitle')}
      errorMessage={errorMessage}
      trackingMessage={TrackingEvents.OO_FALLBACK_500_VIEW}
      staticContext={staticContext}
      meta={meta}
      siteTheme={siteTheme}
      rxName={rxName}
      rxLocations={rxLocation ? [rxLocation] : null}
    />
  )
}

export default OOFallback500
